import { Controller } from "stimulus"

// Shows the page-level loading veil while a `program-events-main` frame navigation is in flight —
// filter apply/reset, active-filter removal, list<->calendar mode switch, and the zip+radius geocode
// search.
export default class extends Controller {
  connect() {
    this.mark = this.mark.bind(this)
    this.unmark = this.unmark.bind(this)
    this.element.addEventListener("turbo:before-fetch-request", this.mark)
    this.element.addEventListener("turbo:frame-render", this.unmark)
    this.element.addEventListener("turbo:fetch-request-error", this.unmark)
  }

  disconnect() {
    this.element.removeEventListener("turbo:before-fetch-request", this.mark)
    this.element.removeEventListener("turbo:frame-render", this.unmark)
    this.element.removeEventListener("turbo:fetch-request-error", this.unmark)
  }

  mark(event) {
    if (this.targetFrame(event) !== "program-events-main") return

    this.element.setAttribute("data-loading", "")
  }

  targetFrame(event) {
    const headers = event.detail && event.detail.fetchOptions && event.detail.fetchOptions.headers

    return headers && headers["Turbo-Frame"]
  }

  unmark() {
    this.element.removeAttribute("data-loading")
  }
}
